export const PRICING_DETAILS_QUERY_KEYS = {
  base: ["pricingDetails"] as const,
  list: () => [...PRICING_DETAILS_QUERY_KEYS.base, "list"] as const,
};
